import React, { Component } from 'react';
import Form from 'react-bootstrap/lib/Form';
import { FieldArray } from 'formik';
import { Map as LeafletMap, TileLayer, Marker, Popup } from 'react-leaflet';
import { Button } from '../../Button';
import { ButtonLoader } from '../../ButtonLoader';
import { Select } from '../../Select';
import { ThematicAreaDropdownOption, DefaultOffice, DistrictDropdownOption } from '../../../utils/enums';
import { AttachmentItem } from '../AttachmentItem';
import { InitiativeMode } from '../../../utils/enums';
// import ReCaptcha from '../../ReCaptchaWrapper';

export class BudgetProjectInitiative extends Component {
	constructor(props) {
		super(props);
		this.captcha = null;
		this.map = null;
	}

	verify = async () => await this.captcha.verify();

	render() {
		const props = this.props;
		return (
			<div className="box margin-top-20">
				<div className="container initiative">
					<div className="initiative-column--70">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="title" className="field__label">
									Temat/tytuł
								</Form.Label>
								<Form.Control
									id="title"
									name="title"
									value={props.title}
									onChange={props.onChange}
									className="field__input"
									onBlur={props.onBlur}
									placeholder="Temat/tytuł"
									title="Wpisz temat/tytuł"
									isInvalid={!!props.errors.title}
									autocomplete="off"
									required={!!props.errors.title}
									aria-required={!!props.errors.title}
								/>
							</div>
							{typeof props.errors.title === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.title}
								</Form.Control.Feedback>
							)}
						</Form.Group>
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="content" className="field__label">
									Treść
								</Form.Label>
								<Form.Control
									as="textarea"
									rows="10"
									id="content"
									name="content"
									value={props.content}
									onChange={props.onChange}
									className="field__textarea"
									onBlur={props.onBlur}
									placeholder="Treść"
									title="Wpisz treść inicjatywy"
									isInvalid={!!props.errors.content}
									autocomplete="off"
									required={!!props.errors.content}
									aria-required={!!props.errors.content}
								/>
							</div>
							{typeof props.errors.content === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.content}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</div>
					<aside className="initiative-column--30">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="thematicAreaId" className="field__label">
									Kategoria
								</Form.Label>
								<Select
									id="thematicAreaId"
									name="thematicAreaId"
									options={[
										{
											value: ThematicAreaDropdownOption.NotSetted,
											text: '[Wybierz]'
										},
										...props.thematicAreas
									]}
									value={props.thematicAreaId}
									onSelect={(option) => props.setFieldValue('thematicAreaId', option.value)}
									required={!!props.errors.thematicAreaId}
									aria-required={!!props.errors.thematicAreaId}
								/>
							</div>
							{typeof props.errors.thematicAreaId === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.thematicAreaId}
								</Form.Control.Feedback>
							)}
						</Form.Group>
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="districtId" className="field__label">
									Obszar
								</Form.Label>
								<Select
									id="districtId"
									name="districtId"
									options={[
										{
											value: DistrictDropdownOption.NotSetted,
											text: '[Wybierz]'
										},
										...props.districts
									]}
									value={props.districtId}
									onSelect={(option) => props.setFieldValue('districtId', option.value)}
									required={!!props.errors.districtId}
									aria-required={!!props.errors.districtId}
								/>
							</div>
							{typeof props.errors.districtId === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.districtId}
								</Form.Control.Feedback>
							)}
						</Form.Group>
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="cost" className="field__label">
									Szacunkowy koszt
								</Form.Label>
								<Form.Control
									id="cost"
									name="cost"
									className="field__input"
									type="text"
									pattern="^[0-9]+([,]?[0-9]+)?$"
									title="Polę musi zawierać liczbę całkowitą i/lub część dziesiętną oddzieloną przecinkiem"
									value={props.cost}
									onChange={props.onChange}
									onBlur={props.onBlur}
									placeholder="Wpisz szacunkowy koszt"
									isInvalid={!!props.errors.cost}
									autocomplete="off"
									required={!!props.errors.cost}
									aria-required={!!props.errors.cost}
								/>
							</div>
							{typeof props.errors.cost === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.cost}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</aside>
				</div>
				<div className="buttons margin-top-20">
					<LeafletMap
						keyboard={false}
						ref={(ref) => {
							this.map = ref;
						}}
						center={{
							lat: props.stateLocationLatitude,
							lng: props.stateLocationLongitude
						}}
						zoom={props.stateZoom}
						style={{ height: '600px', outline: 'none' }}
						onzoomend={props.zoomEnd}
					>
						<TileLayer
							keyboard={false}
							attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
							url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
						/>
						<Marker
							keyboard={false}
							position={{
								lat: props.stateLocationLatitude,
								lng: props.stateLocationLongitude
							}}
							draggable={true}
							onDragend={(e) => props.dragEnd(e, props.setFieldValue)}
						/>
					</LeafletMap>

					<Form.Group>
						<div className="field field--input">
							<Form.Label htmlFor="locationDescription" className="field__label">
								Opis lokalizacji
							</Form.Label>
							<Form.Control
								as="textarea"
								rows="3"
								id="locationDescription"
								name="locationDescription"
								value={props.locationDescription}
								onChange={props.onChange}
								className="field__textarea"
								onBlur={props.onBlur}
								placeholder="Opis lokalizacji"
								title="Wpisz opis lokalizacji"
								isInvalid={!!props.errors.locationDescription}
								autocomplete="off"
								required={!!props.errors.locationDescription}
								aria-required={!!props.errors.locationDescription}
							/>
						</div>
						{typeof props.errors.locationDescription === 'string' && (
							<Form.Control.Feedback type="invalid" className="field--invalid">
								{props.errors.locationDescription}
							</Form.Control.Feedback>
						)}
					</Form.Group>
					<Form.Group>
						<div className="field field--input">
							<Form.Label htmlFor="locationLatitude" className="field__label">
								Szerokość geograficzna
							</Form.Label>
							<Form.Control
								className="field__input"
								id="locationLatitude"
								name="locationLatitude"
								value={props.locationLatitude}
								onChange={(e) => props.changeGeoPoint(e, props.setFieldValue)}
								onBlur={props.onBlur}
								placeholder="Szerokość geograficzna"
								title="Wpisz szerokość geograficzną"
								isInvalid={!!props.errors.locationLatitude}
								autocomplete="off"
								required={!!props.errors.locationLatitude}
								aria-required={!!props.errors.locationLatitude}
							/>
						</div>
						{typeof props.errors.locationLatitude === 'string' && (
							<Form.Control.Feedback type="invalid" className="field--invalid">
								{props.errors.locationLatitude}
							</Form.Control.Feedback>
						)}
					</Form.Group>
					<Form.Group>
						<div className="field field--input">
							<Form.Label htmlFor="locationLongitude" className="field__label">
								Długość geograficzna
							</Form.Label>
							<Form.Control
								className="field__input"
								id="locationLongitude"
								name="locationLongitude"
								value={props.locationLongitude}
								onChange={(e) => props.changeGeoPoint(e, props.setFieldValue)}
								onBlur={props.onBlur}
								placeholder="Długość geograficzna"
								title="Wpisz długość geograficzną"
								isInvalid={!!props.errors.locationLongitude}
								autocomplete="off"
								required={!!props.errors.locationLongitude}
								aria-required={!!props.errors.locationLongitude}
							/>
						</div>
						{typeof props.errors.locationLongitude === 'string' && (
							<Form.Control.Feedback type="invalid" className="field--invalid">
								{props.errors.locationLongitude}
							</Form.Control.Feedback>
						)}
					</Form.Group>
				</div>
				<FieldArray
					id="attachments"
					name="attachments"
					render={(arrayHelpers) => (
						<AttachmentItem
							maxSize={props.attachmentConfiguration.maxAttachmentSize * 1024 * 1024}
							disabled={false}
							items={props.attachments}
							removeable={true}
							baseUrl={'/api/attachments/initiative-attachement'}
							uploadFile={props.uploadFile}
							onAddItem={arrayHelpers.push}
							onRemoveItem={arrayHelpers.remove}
						/>
					)}
				/>
				{typeof props.errors.attachments === 'string' && (
					<Form.Control.Feedback type="invalid" className="field--invalid">
						{props.errors.attachments}
					</Form.Control.Feedback>
				)}

				{!props.isAuth && (
					<div className="buttons margin-top-20">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="replyTo" className="field__label">
									Adres e-mail
								</Form.Label>
								<Form.Control
									id="replyTo"
									name="replyTo"
									value={props.replyTo}
									onChange={props.onChange}
									className="field__input"
									onBlur={props.onBlur}
									placeholder="Adres e-mail"
									title="Wpisz adres e-mail"
									isInvalid={!!props.errors.replyTo}
									required={!!props.errors.replyTo}
									aria-required={!!props.errors.replyTo}
								/>
							</div>
							{typeof props.errors.replyTo === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.replyTo}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</div>
				)}
				{
					/* Nie przechodzi walidacji WCAG2.1 */
					// <div className="buttons margin-top-20">
					// <ReCaptcha ref={(ref) => (this.captcha = ref)} service={props.reCaptchaConfig.reCaptchaKey} />
					// </div>
				}
				{(props.isAuth || props.mode === InitiativeMode.Enabled) && (
					<div className="buttons margin-top-20">
						<ButtonLoader
							type="submit"
							variant="danger"
							disabled={!props.isValid || props.isInitiativeCreating}
							text={'Wyślij'}
							executingText={'Wysyłanie'}
							isExecuting={props.isInitiativeCreating}
						/>
					</div>
				)}
				{!props.isAuth &&
				props.mode !== InitiativeMode.Enabled && (
					<div className="buttons margin-top-20">
						<Button type="submit" variant="danger" disabled={true}>
							Wyślij
						</Button>
						<Form.Control.Feedback type="invalid" className="field--invalid">
							Wymaga zalogowania
						</Form.Control.Feedback>
					</div>
				)}
			</div>
		);
	}
}

BudgetProjectInitiative.defaultProps = {
	title: '',
	content: '',
	replyTo: '',
	attachments: [],
	attachmentConfiguration: {
		maxAttachmentQuantity: 3,
		maxAttachmentSize: 5,
		maxAllAttachmentsSize: 15
	},
	cost: 0,
	thematicAreaId: ThematicAreaDropdownOption.NotSetted,
	districtId: DistrictDropdownOption.NotSetted,
	officeId: DefaultOffice.NotSetted,
	thematicAreas: [],
	districts: [],
	isAuth: false,
	reCaptchaConfig: {
		reCaptchaKey: ''
	},
	isInitiativeCreating: false,
	onSubmit: Function.prototype,
	setFieldValue: Function.prototype
};

// recaptcha key - 6LeO5o4UAAAAACtqupU5rIOHQqQDGFVEUyOXCWO7
